<template>
  <div>
    <van-row class="vin-bar" type="flex" justify="space-between">
      <van-col class="car-info" span="24">
        <div class="carVin">
          <span>{{ service.Vin }}</span>
          <span class="carInfo" @click="toVinSearch">重新识别</span>
        </div>
        <div>{{ service.CarTypeName }}</div>
      </van-col>
      <van-popup
        v-model="isShowVinMoreInfo"
        :safe-area-inset-bottom="true"
        round
        position="bottom"
        :style="{ height: '70%', 'border-radius': '10px 10px 0 0' }"
      >
        <div class="list-root">
          <van-row class="li" v-for="item in cols" :key="item.text" type="flex" justify="space-between">
            <van-col class="key" span="8">{{ item.text }}</van-col>
            <van-col class="value" span="16">{{ data[item.field] || "无" }}</van-col>
          </van-row>
        </div>
      </van-popup>
    </van-row>
    <van-row class="salesman-bar" type="flex" justify="space-between">
      <a class="contacts" :href="`tel:${service.EmployeePhone}`">{{ service.EmployeePhone}}</a>
      <van-col class="car-more" span="10">
        <div class="carInfo" @click="onVinMoreClick">详细车型信息<van-icon name="arrow-down" /></div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import axios from "../utils/axios";
import api from "../services/api";
export default {
  props: {
    service: Object,
  },
  data() {
    return {
      isShowVinMoreInfo: false,
      cols: [
        { text: "车系名称", field: "VehicleTypeName" },
        { text: "变速箱类型", field: "TransmissionDes" },
        { text: "年款", field: "ModelYear" },
        { text: "排量", field: "Displacement" },
        { text: "发动机型号", field: "EngineTypeNo" },
        // { text: "气门数", field: "" },
        { text: "燃油类型", field: "FuelType" },
        { text: "变速器挡数", field: "GearsNum" },
        { text: "进气形式", field: "IntakeForm" },
      ],
      data: {},
      isLoad: false,
    };
  },
  methods: {
    onVinMoreClick() {
      this.isShowVinMoreInfo = true;

      if (!this.isLoad) {
        api
          .GetSalesVehicle({
            VehicleId: this.service.VehicleTypeId,
          })
          .then((res) => {
            this.data = res.Data || {};
          });
        this.isLoad = true;
      }
    },
    toVinSearch() {
      this.$router.push("/vinSearch");
    },
  },
};
</script>

<style lang="scss" scoped>
.contacts {
  color: #333333;
  text-align: left;
  font-size: 0.3rem;
  padding-left:0.8em;
  display: flex;
  align-items: center;
}
.carInfo{
  font-size: 0.24rem;
  color: #4FAE54;
}
.carVin{
  margin-bottom: 3px;
  display: flex;
  justify-content: space-between;
}
//车型信息
.vin-bar {
  font-size: 0.24rem;
  padding: 5px 1em;
  background: rgba(255, 255, 255, 1);
  .car-info {
    color: rgba(102, 102, 102, 1);
    line-height: 1.3em;
  }
  .car-more {
    text-align: right;

    .van-button {
      border-radius: 0.1rem;
    }
  }
}

.list-root {
  font-size: 0.24rem;
  padding: 0 1em;
  border: none;
  .li {
    padding: 1em 0;
    border-bottom: 1px rgba(248, 246, 246, 1) solid;
    line-height: 0.6rem;
    height: 0.6rem;
    .key {
      font-weight: 500;
      color: rgba(153, 153, 153, 1);
    }
    .value {
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      text-align: right;
    }
  }
}
</style>
